import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import classNames from 'classnames';
import Icon from 'components/Icon';
import Style from './PlayButton.module.scss';

const PlayButton = ({
  thinIcon = true,
  link = null,
  playButtonClick = () => {},
  render = false,
  ariaLabel = '',
}) => {
  if (!render) return null;
  let icon = 'play-button';
  let viewBox = null;
  if (thinIcon) {
    icon = 'play-button-thin';
    viewBox = '1 1 36 36';
  }
  return (
    <div className={Style.playButtonOverlay}>
      <Link
        aria-label={ariaLabel || 'play button'}
        className={classNames([Style.playButton])}
        to={link}
        onClick={playButtonClick}
      >
        <Icon icon={icon} color="white" size="full" viewBox={viewBox} />
      </Link>
    </div>
  );
};

PlayButton.propTypes = {
  thinIcon: PropTypes.bool,
  Style: PropTypes.shape({}),
  link: PropTypes.string,
  playButtonClick: PropTypes.func,
  render: PropTypes.bool,
  ariaLabel: PropTypes.string,
};

export default PlayButton;
